import { hideLoading, showLoading } from 'react-redux-loading-bar';
import api from '../../utils/api/api';

import {
  SET_RECEIVE_THREAD,
  SET_CREATE_THREAD,
  SET_DOWN_VOTE_THREAD,
  SET_NEUTRAL_VOTE_THREAD,
  SET_UP_VOTE_THREAD,
} from '../../utils/common/constant';

const ActionType = {
  SET_RECEIVE_THREAD,
  SET_CREATE_THREAD,
  SET_DOWN_VOTE_THREAD,
  SET_NEUTRAL_VOTE_THREAD,
  SET_UP_VOTE_THREAD,
};

const receiveThreadActionCreator = (threads) => {
  return {
    type: ActionType.SET_RECEIVE_THREAD,
    payload: {
      threads,
    },
  };
};

const createThreadActionCreator = (thread) => {
  return {
    type: ActionType.SET_CREATE_THREAD,
    payload: {
      thread,
    },
  };
};

const downVoteThreadActionCreator = ({ threadId, userId }) => {
  return {
    type: ActionType.SET_DOWN_VOTE_THREAD,
    payload: {
      threadId,
      userId,
    },
  };
};

const neutralVoteThreadActionCreator = ({ threadId, userId }) => {
  return {
    type: ActionType.SET_NEUTRAL_VOTE_THREAD,
    payload: {
      threadId,
      userId,
    },
  };
};

const upVoteThreadActionCreator = ({ threadId, userId }) => {
  return {
    type: ActionType.SET_UP_VOTE_THREAD,
    payload: {
      threadId,
      userId,
    },
  };
};

const asyncCreateThread = ({ title, body, category }) => {
  return async (dispatch) => {
    dispatch(showLoading());

    try {
      const thread = await api.createThread({
        title, body, category,
      });

      dispatch(createThreadActionCreator(thread));
    } catch (error) {
      dispatch(hideLoading());
      alert(error.message);
    }

    dispatch(hideLoading());
  };
};

const asyncDownVoteThread = (threadId) => {
  return async (dispatch, getState) => {
    const { authUser } = getState();

    dispatch(showLoading());
    dispatch(downVoteThreadActionCreator({ threadId, userId: authUser.id }));

    try {
      await api.downVoteThread(threadId);
    } catch (error) {
      dispatch(downVoteThreadActionCreator({ threadId, userId: authUser.id }));
      dispatch(hideLoading());
      alert(error.message);
    }

    dispatch(hideLoading());
  };
};

const asyncNeutralVoteThread = (threadId) => {
  return async (dispatch, getState) => {
    const { authUser } = getState();

    dispatch(showLoading());
    dispatch(neutralVoteThreadActionCreator({ threadId, userId: authUser.id }));

    try {
      await api.neutralVoteThread(threadId);
    } catch (error) {
      dispatch(neutralVoteThreadActionCreator({ threadId, userId: authUser.id }));
      dispatch(hideLoading());
      alert(error.message);
    }

    dispatch(hideLoading());
  };
};

const asyncUpVoteThread = (threadId) => {
  return async (dispatch, getState) => {
    const { authUser } = getState();

    dispatch(showLoading());
    dispatch(upVoteThreadActionCreator({ threadId, userId: authUser.id }));

    try {
      await api.upVoteThread(threadId);
    } catch (error) {
      dispatch(upVoteThreadActionCreator({ threadId, userId: authUser.id }));
      dispatch(hideLoading());
      alert(error.message);
    }

    dispatch(hideLoading());
  };
};

export {
  ActionType,
  receiveThreadActionCreator,
  createThreadActionCreator,
  downVoteThreadActionCreator,
  neutralVoteThreadActionCreator,
  upVoteThreadActionCreator,
  asyncCreateThread,
  asyncDownVoteThread,
  asyncNeutralVoteThread,
  asyncUpVoteThread,
};
